import { useEffect, useState } from 'react'
import { useContactContext } from "../ContactShow"
import PersonnePhysique from './PersonnePhysique'
import PersonneMorale from './PersonneMorale'

// Composant pour les informations générales
const GeneralInformation = () => {
  const { contact, wasUpdated, isPendingAction } = useContactContext()
  const [animateUpdate, setAnimateUpdate] = useState(false)
  
  useEffect(() => {
    if (wasUpdated) {
      setAnimateUpdate(true)
      const timer = setTimeout(() => {
        setAnimateUpdate(false)
      }, 2000) // Durée de l'animation
      
      return () => clearTimeout(timer)
    }
  }, [wasUpdated, isPendingAction])
  
  return (
    <div className="mb-8">
      <h2 className="text-xl font-semibold mb-2">Informations générales</h2>
      <div className={`bg-gray-100 p-6 rounded-none transition-all duration-1000 ${animateUpdate ? 'skeleton' : ''}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-start">
          { contact.type === 'PersonnePhysique' && <PersonnePhysique />} 
          { contact.type === 'PersonneMorale' && <PersonneMorale />} 
        </div>
      </div>
    </div>
  )
}

export default GeneralInformation